export default __webpack_public_path__ + "static/media/guide_bg.e284816a.png";